module.exports = "<div class=\"faded-background\">\r\n  <span class=\"one\"></span>\r\n  <span class=\"two\"></span>\r\n  <span class=\"three\"></span>\r\n  <span class=\"four\"></span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/shared/components/dots-loader/dots-loader.component.html
// module id = ../../../../../src/app/shared/components/dots-loader/dots-loader.component.html
// module chunks = main